export default __webpack_public_path__ + "static/react-icon-443ec513ef0752536b8a6ab590af88c2.png";